import html2canvas from 'html2canvas';

interface GenerateThumbnailOptions {
  html: string;
  css: string;
  width?: number;
  height?: number;
}

// Generates a thumbnail image from HTML and CSS content using html2canvas
export async function generateThumbnail({
  html,
  css,
  width = 360,
  height = 240,
}: GenerateThumbnailOptions): Promise<string> {
  // Creates an iframe to render the HTML and CSS
  const iframe = document.createElement('iframe');
  iframe.style.position = 'absolute';
  iframe.style.left = '-9999px'; // Positions iframe off-screen
  document.body.appendChild(iframe);

  const doc = iframe.contentWindow?.document;
  if (!doc) {
    throw new Error('Failed to access iframe document');
  }

  // Writes the HTML and CSS to the iframe document
  doc.open();
  doc.write(
    `<!doctype html><html><head><style>html,body{margin:0;padding:0;}${css}</style></head><body>${html}</body></html>`
  );
  doc.close();

  // Waits briefly to ensure resources (e.g., images) load
  await new Promise((resolve) => setTimeout(resolve, 300));

  // Captures the rendered content as a canvas
  const canvas = await html2canvas(doc.body as HTMLElement, {
    width,
    height,
    windowWidth: width,
    windowHeight: height,
  });

  // Converts the canvas to a data URL (PNG format)
  const dataUrl = canvas.toDataURL('image/png');

  // Removes the iframe from the DOM
  document.body.removeChild(iframe);
  return dataUrl; // Returns the thumbnail as a base64-encoded image
}
